import { Route } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./layout/shell/shell.component').then((m) => m.ShellComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./features/home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: 'about',
        loadComponent: () => import('./features/about/about.component').then((m) => m.AboutComponent),
      },
      {
        path: 'terms-of-use',
        loadComponent: () => import('./features/legal/terms-of-use/terms-of-use.component').then((m) => m.TermsOfUseComponent),
      },
      {
        path: 'privacy-policy',
        loadComponent: () => import('./features/legal/privacy-policy/privacy-policy.component').then((m) => m.PrivacyPolicyComponent),
      },
      {
        path: 'news',
        loadComponent: () => import('./features/news/news-list.component').then((m) => m.NewsListComponent),
      },
      {
        path: 'news/:slug',
        loadComponent: () => import('./features/news/news-article.component').then((m) => m.NewsArticleComponent),
      },
      {
        path: 'catalog',
        loadChildren: () => import('./features/catalog/catalog.routes').then((m) => m.catalogRoutes),
      },
      {
        path: 'parts/:articleId',
        loadComponent: () => import('./features/product/product-detail.component').then((m) => m.ProductDetailComponent),
      },
      {
        path: 'cart',
        loadChildren: () => import('./features/cart/cart.routes').then((m) => m.cartRoutes),
      },
      {
        path: 'profile',
        canActivate: [authGuard],
        loadChildren: () => import('./features/profile/profile.routes').then((m) => m.profileRoutes),
      },
      {
        path: 'top-catalog',
        canActivate: [authGuard],
        loadComponent: () => import('./features/top-catalog/top-catalog.component').then(m => m.TopCatalogComponent),
      },
    ],
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: 'redirect/payment',
    loadComponent: () => import('./features/payment/payment-processing.component').then((m) => m.PaymentProcessingComponent),
    data: { type: 'REDIRECT_PAYMENT' },
  },
  {
    path: 'redirect/approve',
    loadComponent: () => import('./features/payment/payment-processing.component').then((m) => m.PaymentProcessingComponent),
    data: { type: 'APPROVE_PAYMENT' },
  },
  {
    path: 'payment/success',
    loadComponent: () => import('./features/payment/payment-processing.component').then((m) => m.PaymentProcessingComponent),
    data: { type: 'PAYMENT_SUCCESS' },
  },
  {
    path: 'payment/error',
    loadComponent: () => import('./features/payment/payment-processing.component').then((m) => m.PaymentProcessingComponent),
    data: { type: 'PAYMENT_FAIL' },
  },
  {
    path: '404',
    loadComponent: () => import('./features/not-found/not-found.component').then(m => m.NotFoundComponent),
  },
  {
    path: '**',
    redirectTo: '/404',
  },
];
